export default {
  about: {
    en: 'About product',
  },
  hintForPremiumTitle: {
    en: 'What will I get for extra payment?',
  },
}
